import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import Landing from './Landing'
import Why from './pages/Why'
import Pricing from './pages/Pricing'
import Roadmap from './pages/Roadmap'
import Changelog from './pages/Changelog'
import WhatIs from './pages/WhatIs'
import Compare from './pages/Compare'
import GithubDeployProject from './pages/GithubDeployProject'
import Docs from './pages/Docs'
import OpendeployCapabilitiesDocs from './pages/OpendeployCapabilitiesDocs'
import AgentPlatformsDocs from './pages/AgentPlatformsDocs'
import Blog from './pages/Blog'
import BlogPostPage from './pages/BlogPost'
import Events from './pages/Events'
import EventDetailPage from './pages/EventDetail'
import Templates from './pages/Templates'
import TemplateDetail from './pages/TemplateDetail'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import AuthCallbackPage from './pages/AuthCallback'
import { VERCEL, RAILWAY, RENDER } from './pages/vs.data'
import BetaModal from './components/BetaModal'
import ScrollToTop from './components/ScrollToTop'

import './styles/reset.css'
import './styles/landing-v2.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <BetaModal />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/docs/what-opendeploy-can-do" element={<OpendeployCapabilitiesDocs />} />
          <Route path="/docs/agent-platforms-plugins-skills" element={<AgentPlatformsDocs />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:slug" element={<EventDetailPage />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/templates/:slug" element={<TemplateDetail />} />
          <Route path="/why" element={<Why />} />
          <Route path="/thesis" element={<Navigate to="/why" replace />} />
          <Route path="/how" element={<Navigate to="/#how" replace />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/changelog" element={<Changelog />} />
          <Route path="/what-is-opendeploy" element={<WhatIs />} />
          <Route path="/github/:owner/:repo" element={<GithubDeployProject />} />
          <Route path="/vs/vercel" element={<Compare data={VERCEL} />} />
          <Route path="/vs/railway" element={<Compare data={RAILWAY} />} />
          <Route path="/vs/render" element={<Compare data={RENDER} />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
)
